import PropTypes from "prop-types";
import CategoryHeaderVideo from "../CategoryHeaderVideo";
import CategoryHeaderImage from "../CategoryHeaderImage";
import * as types from "./constants";

const CategoryHeaderMedia = ({
  viewportCategory,
  mediaType,
  featuredHeaderData
}) => {
  const CategoryHeaderMediaTypes = {
    image: CategoryHeaderImage,
    video: CategoryHeaderVideo
  };
  const Component = CategoryHeaderMediaTypes[mediaType];

  if (Component) {
    return (
      <Component
        viewportCategory={viewportCategory}
        featuredHeaderData={featuredHeaderData}
      />
    );
  }

  return null;
};

CategoryHeaderMedia.propTypes = {
  mediaType: PropTypes.oneOf(Object.values(types)).isRequired,
  viewportCategory: PropTypes.string.isRequired,
  featuredHeaderData: PropTypes.shape({
    app: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string
    }),
    displayText: PropTypes.string,
    isEnabled: PropTypes.bool,
    web: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string
    })
  })
};

export default CategoryHeaderMedia;
